import { z } from "zod";
//#region src/auth-tokens.ts
const tokenPairResponseSchema = z.object({
	accessToken: z.string().min(1),
	refreshToken: z.string().min(1),
	/** ISO-8601 timestamp at which the access token expires. */
	expiresAt: z.string().datetime(),
	/**
	* Present and true when the user must change the password before anything else. The server
	* gates on it: the access token of the same pair carries the claim `fpc`, and core-api refuses
	* every route outside the change-password allowlist with 403 `password_change_required` until
	* the change. A client sends the user to `/change-password` when it adopts such a pair.
	*/
	forcePasswordChange: z.boolean().optional()
}).strict();
//#endregion
export { tokenPairResponseSchema };

//# sourceMappingURL=auth-tokens.js.map